import { HaloVideo } from './HaloVideo';
import { playOpenWhoosh } from '@/lib/sound';

interface AIAssistantFabProps {
  onClick: () => void;
}

export function AIAssistantFab({ onClick }: AIAssistantFabProps) {
  const handleClick = () => {
    playOpenWhoosh();
    onClick();
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Abrir Optimal AI"
      title="Optimal AI"
      className="ai-fab fixed bottom-6 right-6 z-[60] w-14 h-14 rounded-full overflow-hidden cursor-pointer text-primary transition-all hover:scale-105 active:scale-100 max-[760px]:bottom-4 max-[760px]:right-4 max-[760px]:w-12 max-[760px]:h-12 p-0 border-0 bg-transparent"
    >
      <HaloVideo />
    </button>
  );
}
